import { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Calendar } from '@/components/ui/calendar';
import { CalendarDays } from 'lucide-react';

const toIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export function DatePickerInput({ value, onChange, placeholder = 'Pick date', className = '', testid }) {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(`${value}T00:00:00`) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} className={`flex items-center gap-1.5 px-2 rounded-md border text-left ${className} ${value ? 'text-gray-900' : 'text-gray-400'}`}>
          <CalendarDays className="h-3.5 w-3.5 text-gray-400" />{selected ? selected.toLocaleDateString() : placeholder}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-white" align="start">
        <Calendar mode="single" selected={selected} defaultMonth={selected} onSelect={d => { if (d) { onChange(toIso(d)); setOpen(false); } }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
